module.exports = "#me-text.flipped {\n  -webkit-transform: transformX(98.5%) rotateX(0deg) rotateY(170deg);\n}\n\n#me-text .md {\n  -webkit-transform: rotateY(170deg) transformX(98.5%);\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./styles3.css
 ** module id = 86
 ** module chunks = 0 1
 **/